/* @flow */
const prefix = str => `station/chat/${str}`;

// Slack Community Chat Actions
export const JOIN_COMMUNITY_CHAT_CHANNEL = prefix('JOIN_COMMUNITY_CHAT_CHANNEL');
export const CHAT_INVITE_STATUS_UPDATE = prefix('CHAT_INVITE_STATUS_UPDATE');
export const CLOSE_CHAT_MODAL = prefix('CLOSE_CHAT_MODAL');
export const LAUNCH_COMMUNITY_CHAT = prefix('LAUNCH_COMMUNITY_CHAT');



// WEBPACK FOOTER //
// ./src/app/modules/chat/action-types.js